// Portfolio roster — every live Wolf Technologies app with a public web version.
// Icons live in public/portfolio/<slug>.<ext> (copied from each app's own
// public icon set). URLs are the apps' production custom domains.

export const portfolioApps = [
  {
    slug: 'babytrack',
    name: 'BabyTrack',
    category: 'Health & Family',
    icon: '/portfolio/babytrack.webp',
    url: 'https://babytrack.wolftechnologies.co.uk',
    blurb:
      'Complete newborn care companion — feeds, sleep, nappies and growth percentiles with beautiful charts, multi-caregiver sharing and AI-powered insights for sleep-deprived parents.',
  },
  {
    slug: 'wealthtracker',
    name: 'Wealth Tracker',
    category: 'Finance',
    icon: '/portfolio/wealthtracker.webp',
    url: 'https://wealth.wolftechnologies.co.uk',
    blurb:
      'Personal net-worth dashboard covering stocks, property, pensions and crypto — portfolio history, asset allocation breakdowns and goal tracking in one secure view.',
  },
  {
    slug: 'chessmate',
    name: 'ChessMate',
    category: 'Games',
    icon: '/portfolio/chessmate.png',
    url: 'https://chessmate.wolftechnologies.co.uk',
    blurb:
      'Full-featured chess platform with real-time online multiplayer, daily tactics puzzles, an adjustable engine opponent and rated ladders — built on live WebSocket infrastructure.',
  },
  {
    slug: 'kingdomtd',
    name: 'Kingdom Siege TD',
    category: 'Games',
    icon: '/portfolio/kingdomtd.webp',
    url: 'https://kingdomtd.wolftechnologies.co.uk',
    blurb:
      'Fast-paced tower defence with escalating campaigns, hero upgrades and a full free-to-play progression ladder — cloud-saved so players continue seamlessly across devices.',
  },
  {
    slug: 'pacepact',
    name: 'PacePact',
    category: 'Health & Fitness',
    icon: '/portfolio/pacepact.webp',
    url: 'https://pacepact.wolftechnologies.co.uk',
    blurb:
      'Fortnightly run and walk commitment challenges with GPS-verified sessions, tiered leagues, guilds and a closed-loop credit economy that keeps players accountable.',
  },
  {
    slug: 'animationbuddy',
    name: 'Atlas Animation Buddy',
    category: 'AI & Creative',
    icon: '/portfolio/animationbuddy.svg',
    url: 'https://animationbuddy.wolftechnologies.co.uk',
    blurb:
      'AI animation studio in the browser — generative storyboards and rendered video produced by a serverless GPU-free pipeline (SQS + Lambda + ffmpeg) with a credits marketplace.',
  },
  {
    slug: 'cadence',
    name: 'Cadence',
    category: 'AI & Creative',
    icon: '/portfolio/cadence.webp',
    url: 'https://cadence.wolftechnologies.co.uk',
    blurb:
      'A voice-first AI companion with a sci-fi HUD interface — natural spoken conversation powered by neural text-to-speech and large language models.',
  },
  {
    slug: 'molehill',
    name: 'Molehill',
    category: 'Productivity',
    icon: '/portfolio/molehill.png',
    url: 'https://molehill.wolftechnologies.co.uk',
    blurb:
      'Task management that turns mountains into molehills — projects, priorities, due dates and focus views wrapped in a fast, offline-capable interface.',
  },
  {
    slug: 'streaks',
    name: 'Streaks',
    category: 'Productivity',
    icon: '/portfolio/streaks.png',
    url: 'https://streaks.wolftechnologies.co.uk',
    blurb:
      'Habit building through unbroken chains — daily check-ins, streak protection, reminders and long-term consistency analytics that make routines stick.',
  },
  {
    slug: 'pomogrow',
    name: 'PomoGrow',
    category: 'Productivity',
    icon: '/portfolio/pomogrow.png',
    url: 'https://pomogrow.wolftechnologies.co.uk',
    blurb:
      'A Pomodoro focus timer where deep work grows a living forest — every completed session plants a tree, gamifying distraction-free concentration.',
  },
  {
    slug: 'recall',
    name: 'Recall',
    category: 'Education',
    icon: '/portfolio/recall.png',
    url: 'https://recall.wolftechnologies.co.uk',
    blurb:
      'GCSE flashcards with a brain: 22 ready-made subject decks, AI that turns pasted notes into cards, and FSRS spaced repetition that resurfaces each card the moment you are about to forget it.',
  },
  {
    slug: 'drift',
    name: 'Drift',
    category: 'Health & Wellness',
    icon: '/portfolio/drift.png',
    url: 'https://drift.wolftechnologies.co.uk',
    blurb:
      'Automatic sleep tracking with bedtime routines, sleep-debt analysis and morning insights — designed to help users drift off sooner and wake up better.',
  },
  {
    slug: 'novacycle',
    name: 'Nova Cycle',
    category: 'Health & Wellness',
    icon: '/portfolio/novacycle.webp',
    url: 'https://nova-cycle.wolftechnologies.co.uk',
    blurb:
      'Private, judgement-free menstrual cycle tracking — predictions, symptom logging and phase insights with a privacy-first architecture that keeps sensitive data safe.',
  },
  {
    slug: 'ember',
    name: 'Ember',
    category: 'Health & Wellness',
    icon: '/portfolio/ember.png',
    url: 'https://ember.wolftechnologies.co.uk',
    blurb:
      'Intermittent fasting made simple — flexible fasting windows, live progress rings, stage-by-stage physiology explainers and streak motivation.',
  },
  {
    slug: 'quench',
    name: 'Quench',
    category: 'Health & Wellness',
    icon: '/portfolio/quench.png',
    url: 'https://quench.wolftechnologies.co.uk',
    blurb:
      'Hydration tracking with smart reminders, personalised daily targets and satisfying progress visuals that make drinking enough water effortless.',
  },
  {
    slug: 'cooksmith',
    name: 'Cooksmith',
    category: 'Lifestyle',
    icon: '/portfolio/cooksmith.png',
    url: 'https://cooksmith.wolftechnologies.co.uk',
    blurb:
      'A personal cookbook, meal planner and grocery-list builder in one — save recipes from anywhere, plan the week and shop from an auto-generated list.',
  },
  {
    slug: 'powderlog',
    name: 'PowderLog',
    category: 'Sports',
    icon: '/portfolio/powderlog.webp',
    url: 'https://powderlog.wolftechnologies.co.uk',
    blurb:
      'The ski-day logbook — GPS-tracked runs, vertical metres, top speeds and season stats, with a friends layer for comparing days on the mountain.',
  },
  {
    slug: 'dates',
    name: 'Dates',
    category: 'Lifestyle',
    icon: '/portfolio/dates.png',
    url: 'https://dates.wolftechnologies.co.uk',
    blurb:
      'Never miss a birthday, anniversary or renewal again — smart countdowns and reminders for every date that matters, beautifully organised.',
  },
  {
    slug: 'braingrid',
    name: 'Brain Grid',
    category: 'Games',
    icon: '/portfolio/braingrid.webp',
    url: 'https://braingrid.wolftechnologies.co.uk',
    blurb:
      'Daily logic-puzzle workouts — bite-sized grid challenges that scale in difficulty, with streaks and stats that keep puzzle fans coming back every morning.',
  },
  {
    slug: 'wolfchat',
    name: 'WolfChat',
    category: 'Social',
    icon: '/portfolio/wolfchat.png',
    url: 'https://wolfchat.wolftechnologies.co.uk',
    blurb:
      'Real-time messaging with rooms, presence and media sharing — a full chat product running on serverless AWS infrastructure.',
  },
];
